<div class="fx-row fx-layout-align-space-between-center">
    <h2 mat-dialog-title class="fx-flex" i18n="Service Tools Certification Dialog|Title">Service Tools</h2>
    <button
        mat-icon-button
        type="button"
        aria-label="Close Service Tools information"
        i18n-aria-label="Service Tools Certification Dialog|Close dialog"
        (click)="close()"
    >
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>

<mat-dialog-content class="dialog-content fx-column fx-layout-gap-24">
    <p i18n="Service Tools Certification Dialog|Introduction">
        Service Tools role grants access to hardware configuration and advanced settings for commissioning and
        maintenance work. This role is meant for experts providing technical support, and
        <strong>only available to Kempower-certified users</strong>
        to ensure that advance features are used by those with knowledge of Kempower's charging stations.
    </p>

    <p class="gap-top" i18n="Service Tools Certification Dialog|Warranty policy">
        This policy aligns with our warranty terms that installation, commissioning, and maintenance work must be done
        by a Kempower-certified professional for the warranty to be valid.
    </p>

    <h2 i18n="Service Tools Certification Dialog|Section heading">Getting Kempower-certified</h2>

    <p>
        To get certified, you need to complete the courses on Power Unit and Satellite system installation,
        commissioning, and maintenance. You can take the courses online via Kempower Academy, or onsite in Lahti,
        Finland; Düsseldorf, Germany; or Durham, North Carolina.
    </p>

    <p class="gap-top">
        <strong i18n="Service Tools Certification Dialog|Academy intro">
            If you have an active
            <a href="https://academy.kempower.com" target="_blank" class="link">Kempower Academy</a>
            account,
        </strong>
        <span i18n="Service Tools Certification Dialog|Academy instructions">
            log in, or check if your organization can provide you access with the same email you use in ChargEye.
        </span>
    </p>

    <p class="gap-top">
        <strong i18n="Service Tools Certification Dialog|No access intro">
            If you don't have access to Kempower Academy
        </strong>
        <span i18n="Service Tools Certification Dialog|Contact instructions"
            >and want to request access or organize an onsite training,
            <a href="https://kempower.com/contact-sales/" target="_blank" class="link">contact Kempower sales</a>.</span
        >
    </p>

    <p class="gap-top">
        <strong i18n="Service Tools Certification Dialog|Certification issue intro">
            If you have a valid certification,
        </strong>
        <span i18n="Service Tools Certification Dialog|Certification issue text"
            >but you received a message saying it is not valid, use this form to
            <a
                href="https://kempower.atlassian.net/servicedesk/customer/portal/2/group/5/create/95"
                target="_blank"
                class="link"
                >get help with your case.
            </a>
        </span>
    </p>

    <p class="gap-top">Note that the certification is valid for one year and you need to renew it yearly.</p>

    <h2 i18n="Service Tools Certification Dialog|Section heading">Getting Service Tools access</h2>

    <p i18n="Service Tools Certification Dialog|Access instructions">
        Organization Admins can give Service Tools role to their users. If the user is certified, access will be granted
        immediately. If they are not certified, once they complete the required courses, they will automatically get
        access. Note that it may take 24 hours for Service Tools to be active in ChargEye.
    </p>
</mat-dialog-content>
